module.exports = __webpack_public_path__ + "static/media/games.109db189.jpg";